import React from 'react';
import { ChevronDown, Loader2 } from 'lucide-react';
import LoteRow from './LoteRow';

/**
 * LotesCategoriaAccordion - Category accordion with lote list
 */
const LotesCategoriaAccordion = ({
    categoria,
    lotes,
    isOpen,
    isExpanding,
    lotesAbiertos,
    onToggleCategoria,
    onToggleLote,
    onNavigate,
    onShare,
    infoRemate
}) => {
    return (
        <div className="bg-white rounded-xl lg:rounded-2xl shadow-xl overflow-hidden transition-all duration-300 hover:shadow-2xl border-2 border-gray-100 hover:border-green-200">
            {/* Header de categoría */}
            <button
                onClick={onToggleCategoria}
                className="w-full px-4 lg:px-6 py-4 lg:py-5 flex items-center justify-between bg-gradient-to-r from-green-600 via-green-500 to-green-600 text-white hover:shadow-2xl transition-all duration-300 ease-in-out group"
            >
                <div className="flex items-center gap-3 lg:gap-4">
                    <div className="text-left">
                        <span className="text-base lg:text-xl font-bold block">{categoria}</span>
                        <span className="text-white/80 text-xs lg:text-sm">Haz clic para ver detalles</span>
                    </div>
                </div>
                <div className="flex items-center gap-2 lg:gap-3">
                    <span className="bg-white/30 backdrop-blur-sm px-3 lg:px-4 py-1.5 lg:py-2 rounded-full text-sm lg:text-lg font-bold shadow-lg">
                        {lotes.length}
                    </span>
                    <ChevronDown
                        className={`w-5 h-5 lg:w-7 lg:h-7 transition-transform duration-300 ease-in-out bg-white/20 rounded-full p-0.5 lg:p-1 ${isOpen ? 'rotate-180' : 'rotate-0'}`}
                    />
                </div>
            </button>

            {/* Lista de lotes dentro de la categoría */}
            <div
                style={{
                    maxHeight: isOpen ? '10000px' : '0px',
                    opacity: isOpen ? 1 : 0,
                    overflow: 'hidden',
                    transition: 'max-height 300ms cubic-bezier(0.4, 0, 0.2, 1), opacity 200ms ease-in-out',
                    transform: 'translateZ(0)',
                    willChange: 'max-height, opacity'
                }}
            >
                <div className="divide-y divide-gray-200">
                    {isExpanding ? (
                        <div className="p-6 lg:p-8 flex flex-col items-center justify-center gap-3">
                            <Loader2 className="w-6 h-6 lg:w-8 lg:h-8 text-green-600 animate-spin" />
                            <p className="text-gray-500 text-xs lg:text-sm">Cargando {lotes.length} lotes...</p>
                        </div>
                    ) : (
                        lotes.map(lote => (
                            <LoteRow
                                key={lote.numero_lote}
                                lote={lote}
                                isExpanded={lotesAbiertos[lote.numero_lote]}
                                onToggle={() => onToggleLote(lote.numero_lote)}
                                onNavigate={onNavigate}
                                onShare={onShare}
                                infoRemate={infoRemate}
                            />
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default LotesCategoriaAccordion;
